import React from 'react';
import { Button, Icon } from '@material-ui/core';
import styles from './DigitalTwinTabEntryCard.module.css';

type Translate = (key: string) => string;

export type DigitalTwinTabEntryCardProps = {
  t: Translate;
  onOpenForecast: () => void;
};

const LifecycleForecastMotif: React.FC = () => (
  <svg className={styles.forecastMotif} viewBox="0 0 220 140" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="dt-line" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#94a3b8" stopOpacity="0.35" />
        <stop offset="50%" stopColor="#6366f1" stopOpacity="0.85" />
        <stop offset="100%" stopColor="#0d9488" stopOpacity="0.55" />
      </linearGradient>
      <linearGradient id="dt-area" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#6366f1" stopOpacity="0.12" />
        <stop offset="100%" stopColor="#6366f1" stopOpacity="0" />
      </linearGradient>
    </defs>
    <text x="16" y="18" className={styles.forecastMotifText}>
      Forecast trajectory
    </text>
    <path
      d="M 24 108 L 52 92 L 88 88 L 124 62 L 158 48 L 196 38"
      fill="none"
      stroke="url(#dt-line)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M 24 108 L 52 92 L 88 88 L 124 62 L 158 48 L 196 38 L 196 108 L 24 108 Z" fill="url(#dt-area)" />
    <circle cx="52" cy="92" r="3.5" fill="#ffffff" stroke="#64748b" strokeWidth="1.2" />
    <circle cx="88" cy="88" r="3.5" fill="#ffffff" stroke="#64748b" strokeWidth="1.2" />
    <circle cx="124" cy="62" r="3.5" fill="#ffffff" stroke="#6366f1" strokeWidth="1.4" />
    <circle cx="158" cy="48" r="3.5" fill="#ffffff" stroke="#6366f1" strokeWidth="1.4" />
    <circle cx="196" cy="38" r="4" fill="#4338ca" stroke="#312e81" strokeWidth="1" />
    <line x1="24" y1="108" x2="196" y2="108" stroke="#e2e8f0" strokeWidth="1" />
    <text x="22" y="126" className={styles.forecastMotifText}>
      Milestones
    </text>
    <line x1="52" y1="118" x2="52" y2="124" stroke="#cbd5e1" strokeWidth="1" />
    <line x1="88" y1="118" x2="88" y2="124" stroke="#cbd5e1" strokeWidth="1" />
    <line x1="124" y1="118" x2="124" y2="124" stroke="#a5b4fc" strokeWidth="1.5" />
    <line x1="158" y1="118" x2="158" y2="124" stroke="#a5b4fc" strokeWidth="1.5" />
    <line x1="196" y1="118" x2="196" y2="124" stroke="#4338ca" strokeWidth="2" />
  </svg>
);

export const DigitalTwinTabEntryCard: React.FC<DigitalTwinTabEntryCardProps> = ({ t, onOpenForecast }) => (
  <section className={styles.entrySection} aria-labelledby="digital-twin-entry-heading">
    <div className={styles.entryCard}>
      <div className={styles.entryInner}>
        <div>
          <div className={styles.entryMeta}>
            <span className={styles.entryKicker}>
              <Icon className={styles.entryKickerIcon}>insights</Icon>
              {t('digitalTwin.entryFeatureLabel')}
            </span>
            <span className={styles.entryMetaDivider} aria-hidden="true" />
            <span className={styles.entryMetaPill}>{t('digitalTwin.entryModelLine')}</span>
          </div>
          <h2 id="digital-twin-entry-heading" className={styles.entryTitle}>
            {t('digitalTwin.title')}
          </h2>
          <p className={styles.entryDescription}>{t('digitalTwin.entryDescription')}</p>
          <div className={styles.entryActions}>
            <Button
              type="button"
              variant="contained"
              color="primary"
              className={styles.ctaButton}
              onClick={onOpenForecast}
              disableElevation
            >
              {t('digitalTwin.ctaOpenForecast')}
              <Icon className={styles.ctaIcon}>arrow_downward</Icon>
            </Button>
          </div>
        </div>
        <div className={styles.entryVisual}>
          <LifecycleForecastMotif />
        </div>
      </div>
    </div>
  </section>
);
